type AcceptableArrayTypes = string | number;

export const prepareQueryArrayParam = (fieldName: string, array: Array<AcceptableArrayTypes>) =>
  array.reduce(
    (acc, currentValue, idx, currentArray) =>
      `${acc}${fieldName}=${currentValue}${idx !== currentArray.length - 1 ? '&' : ''}`,
    '',
  );
